import CitiesComponent from "../../../Components/system settings/CitiesComponent";
import HeaderBar from "../../../Components/UI/headerbar";

const CitiesPage = () => {
  return (
    <div>
      <HeaderBar title={"إعدادات المدن"} content={"إدارة المدن للنظام"} />

      <CitiesComponent />
    </div>
  );
};

export default CitiesPage;
